import { type DimensionKey } from '../types';

const DIMENSION_FROM_LABEL: Record<string, DimensionKey> = {
  cats: 'cats',
  dogs: 'dogs',
  kids: 'kids',
  'energy level': 'energy',
  energy: 'energy',
  affection: 'affection',
  'new people': 'newPeople',
  housemanners: 'housemanners',
};

/**
 * Parses Shelterluv `AttributeName` like `-Cats: 4) …` or `-Energy Level: 2) …`.
 */
export function parseBehaviorAttribute(
  attributeName: string,
): { key: DimensionKey; level: number } | null {
  const m = attributeName.match(/^-\s*([^:]+):\s*(\d+)\)\s*/i);
  if (!m) return null;

  const rawDim = m[1].trim().replace(/\s+/g, ' ').toLowerCase();
  const key = DIMENSION_FROM_LABEL[rawDim];
  if (!key) return null;

  const level = Number(m[2]);
  if (!Number.isFinite(level) || level < 1 || level > 5) return null;

  return { key, level };
}
